import { ReceivedDataMessage } from "@livekit/components-core";
import {
  RoomContext,
  useDataChannel,
  useTracks,
} from "@livekit/components-react";
import {
  DataPacket_Kind,
  LocalParticipant,
  RemoteParticipant,
  Track,
} from "livekit-client";
import { useContext, useEffect, useState } from "react";
import minimizeIcon from "../../assets/minimize.png";
import { useRecoilState } from "recoil";
import { isRDPMinizedState } from "../../atom/atom";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


function RemoteControl() {
  const { message, send } = useDataChannel("RDP-channel", (msg) => action(msg));
  const room = useContext(RoomContext);
  const [remoteAccessLock, setRemoteAccessLock] = useState(false);
  const [remoteUserSid, setRemoteUserSid] = useState("");
  const [remoteAccessUserName, setRemoteAccessUserName] = useState("");
  const [screenOwnerName, setScreenOwnerName] = useState("");
  const tracks = useTracks(
    [{ source: Track.Source.ScreenShare, withPlaceholder: false }],
    {}
  );
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();

  const [isRDPMinized, setIsRDPMinized] = useRecoilState(isRDPMinizedState);
  const videoContainer = document.createElement("div");
  videoContainer.classList.add("video-container");

  const createVideoElement = (participantSid: string) => {
    const video = document.createElement("video");
    const controlButton = document.createElement("button");
    const screenOwnerLabel = document.createElement("div");
    const minimizeIconElement = document.createElement("img"); 
    const videoContainer = document.createElement("div");
  
    video.controls = false;
    video.srcObject =
      tracks.find((track) => track.participant.sid === participantSid)?.publication?.track?.mediaStream ?? null;
    video.classList.add("rdp");
    video.setAttribute("tabindex", "0");
    video.play();
  
  
controlButton.textContent = "Stop Access";
controlButton.classList.add("control-button");
controlButton.style.backgroundColor = "#f91f31";
controlButton.style.color = "#fff";
controlButton.style.fontWeight = "bold";
controlButton.style.padding = "8px 16px";
controlButton.style.border = "none";
controlButton.style.borderRadius = "4px";
controlButton.style.position = "absolute";
controlButton.style.top = "10px";
controlButton.style.left = "50%";
controlButton.style.transform = "translateX(-50%)";
controlButton.style.display = "none";
controlButton.style.zIndex = "10000";
controlButton.style.cursor = "pointer";

screenOwnerLabel.textContent = `${screenOwnerName}'s Screen`; 
screenOwnerLabel.classList.add("screen-owner-label");
screenOwnerLabel.style.position = "absolute";
screenOwnerLabel.style.bottom = "20px";
screenOwnerLabel.style.left = "10px";
screenOwnerLabel.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
screenOwnerLabel.style.color = "#fff";
screenOwnerLabel.style.padding = "6px 12px";
screenOwnerLabel.style.borderRadius = "4px";
screenOwnerLabel.style.fontWeight = "bold";
screenOwnerLabel.style.zIndex = "10000";

minimizeIconElement.src = minimizeIcon;
minimizeIconElement.alt = "Minimize";
minimizeIconElement.classList.add("minimize-icon");
minimizeIconElement.style.position = "absolute";
minimizeIconElement.style.top = "10px";
minimizeIconElement.style.left = "calc(50% + 90px)";
minimizeIconElement.style.transform = "translateX(-50%)";
minimizeIconElement.style.width = "24px";
minimizeIconElement.style.height = "24px";
minimizeIconElement.style.cursor = "pointer";
minimizeIconElement.style.zIndex = "10001";

videoContainer.appendChild(video);
videoContainer.appendChild(controlButton);
videoContainer.appendChild(minimizeIconElement);
videoContainer.appendChild(screenOwnerLabel);
document.body.appendChild(videoContainer);

videoContainer.addEventListener("mousemove", (event) => {
  if (event.clientY <= 50) {
    controlButton.style.display = "block";
    minimizeIconElement.style.display = "block";
  } else {
    controlButton.style.display = "none";
    minimizeIconElement.style.display = "none";
  }
});
  
    minimizeIconElement.addEventListener("click", () => {

      const rdpElement = document.querySelector('.rdp') as HTMLVideoElement;

      if (rdpElement && !rdpElement.classList.contains('minimized')) {
        rdpElement.classList.add('minimized');
        rdpElement.style.pointerEvents = 'none';
        console.log('this is hit again')
        setIsRDPMinized(true);
      }

    
    });
  
    controlButton.onclick = () => {
      videoContainer.remove();

      setIsRDPMinized(false);

      send(encoder.encode(JSON.stringify({ type: "message", text: "controlAccessEnd" })), {
        kind: DataPacket_Kind.RELIABLE,
        destination: [tracks[0].participant.sid],
      });
      send(encoder.encode(JSON.stringify({ message: "removeRemoteAccessUser", text: "" })), {
        kind: DataPacket_Kind.RELIABLE
      });
      setRemoteAccessUserName('');
    };
  };
  
  

  const captureMousePos = (participantSid: string) => {
    const encoder = new TextEncoder();
    const video = document.querySelector(".rdp") as HTMLVideoElement;
    let moveTimeout: string | number | NodeJS.Timeout | undefined;

    const sendMousePos = (event: MouseEvent) => {
      clearTimeout(moveTimeout);
      const videoWidth = video.clientWidth;
      const videoHeight = video.clientHeight;
      const mousePos = JSON.stringify({
        type: "mouseMove",
        x: (event.clientX / videoWidth).toFixed(2),
        y: (event.clientY / videoHeight).toFixed(2),
      });
      moveTimeout = setTimeout(
        () =>
          send(encoder.encode(mousePos), {
            kind: DataPacket_Kind.LOSSY,
            destination: [participantSid],
          }),
        10
      );
    };

    const sendMouseDown = (event: MouseEvent) => {
      const videoWidth = video.clientWidth;
      const videoHeight = video.clientHeight;
      const mouseClick = JSON.stringify({
        type: "mouseDown",
        x: (event.clientX / videoWidth).toFixed(2),
        y: (event.clientY / videoHeight).toFixed(2),
        button: event.button,
      });
      send(encoder.encode(mouseClick), {
        kind: DataPacket_Kind.LOSSY,
        destination: [participantSid],
      });
    };

    const sendKeyPressDetais = async (event: KeyboardEvent) => {

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (
        event.key === "Meta" || 
        (event.altKey && event.key === "Tab") || 
        (event.metaKey && event.key === "Tab")
      ) {
        return;
      }
      if (!!event.ctrlKey && event.keyCode === 86) {
        const clipboardContent = JSON.stringify({
          type: "clipboardContent",
          content: await (window as any).electronAPI?.getClipboardText()
        });
        send(encoder.encode(clipboardContent), {
          kind: DataPacket_Kind.LOSSY,
          destination: [participantSid],
        });
      }
      else {

        const keyPress = JSON.stringify({
          type: "keyDown",
          key: event.keyCode,
          shiftKey: event.shiftKey,
          ctrlKey: event.ctrlKey,
          altKey: event.altKey,
          command: event.metaKey,
        });
        send(encoder.encode(keyPress), {
          kind: DataPacket_Kind.LOSSY,
          destination: [participantSid],
        });
      }
    };

    const sendMouseUp = (event: MouseEvent) => {
      const videoWidth = video.clientWidth;
      const videoHeight = video.clientHeight;
      const mouseClick = JSON.stringify({
        type: "mouseUp",
        x: (event.clientX / videoWidth).toFixed(2),
        y: (event.clientY / videoHeight).toFixed(2),
        button: event.button,
      });
      send(encoder.encode(mouseClick), {
        kind: DataPacket_Kind.LOSSY,
        destination: [participantSid],
      });
    };

    const sendMouseWheel = (event: WheelEvent) => {
      const delta = event.deltaY;
      const scrollDir = JSON.stringify({
        type: "mouseScroll",
        delta,
      });
      send(encoder.encode(scrollDir), {
        kind: DataPacket_Kind.LOSSY,
        destination: [participantSid],
      });
    };

    video.addEventListener("mousemove", sendMousePos);
    video.addEventListener("mousedown", sendMouseDown);
    video.addEventListener("mouseup", sendMouseUp);
    video.addEventListener("wheel", sendMouseWheel);
    video.addEventListener("keydown", (event) => {
      sendKeyPressDetais(event).catch((err) => console.error("Error in key press:", err));
    });
  };

  const handleUserSelect = () => {
  
  send(encoder.encode(JSON.stringify({ type: "message", text: "controlAccessReq" })),
        { kind: DataPacket_Kind.RELIABLE, destination: [tracks[0].participant.sid] }
      );
    
  };

  const resumeRDP = () => {
    
    const rdpElement = document.querySelector('.rdp.minimized') as HTMLVideoElement;
  
    if (rdpElement) {

      setIsRDPMinized(false);
      rdpElement.classList.remove('minimized');
      rdpElement.style.zIndex = ''; 
      rdpElement.style.opacity = ''; 
      rdpElement.style.pointerEvents = ''; 
      rdpElement.style.transform = '';
    } else {
      console.warn('No minimized RDP element found.');
    }
  };
  

  const action = (message: ReceivedDataMessage<"RDP-channel">) => {
    if (!message) return;
    const msg = decoder.decode(message.payload);
    let _msg = JSON.parse(msg);
    if (
      _msg.type === "message" &&
      _msg.text === "controlAccessGrant" &&
      message.from?.sid
    ) {
      createVideoElement(message.from.sid);
      captureMousePos(message.from.sid);
      setRemoteUserSid(message.from.sid);
      setRemoteAccessUserName(room?.localParticipant?.name ?? "");
      send(encoder.encode(JSON.stringify({ message: "setRemoteAccessUser", text: room?.localParticipant?.name })), {
        kind: DataPacket_Kind.RELIABLE
      });      
    }else if (_msg.type === "clipboardContent") {
      (window as any).electronAPI?.setClipboardText(_msg.content);
    }else if (_msg.message === 'setRemoteAccessUser'){
      setRemoteAccessUserName(_msg.text)
    }
    else if (_msg.message === 'removeRemoteAccessUser'){
      setRemoteAccessUserName('');
    }
  }

  useEffect(() => {
    setTimeout(() => {
      tracks[0]?.participant?.sid &&
      send(encoder.encode(JSON.stringify({ message: "getRemoteAccessUser", text: "" })), {
        kind: DataPacket_Kind.RELIABLE,
        destination: [tracks[0].participant.sid],
      })}, 5000); 
  }, [tracks.length]);

  const setRemoteAccessUser = (newParticipant: RemoteParticipant) => {
    send(encoder.encode(JSON.stringify({ message: "setRemoteAccessUser", text: room?.localParticipant?.name })), {
      kind: DataPacket_Kind.RELIABLE,
      destination: [newParticipant.sid],
    });
  }

  useEffect(() => {
    if (tracks.length === 0 || !tracks.find(track => track.participant?.sid === remoteUserSid)) {
      let element = document.querySelector(".video-container");
      element?.remove();
      let videoContainer = document.querySelector(".rdp")?.parentElement;
      videoContainer?.remove();
      remoteAccessUserName.length > 0 && room?.state == "connected" && send(encoder.encode(JSON.stringify({ message: "removeRemoteAccessUser", text: "" })), {
        kind: DataPacket_Kind.RELIABLE
      });
      setRemoteUserSid("");
      setIsRDPMinized(false);
      remoteAccessUserName?.length > 0 && setRemoteAccessUserName("");
    } 
  }, [tracks.length])

  useEffect(() => {
    if (tracks.length === 0)
      return;
    let metadata;
    try { metadata = JSON.parse(tracks[0]?.participant?.metadata ?? "") }
    catch { metadata = {}; }
    setScreenOwnerName(metadata.pName);
    if (!!metadata.remoteAccessLock)
      setRemoteAccessLock(true);
      
    else{ 
      setRemoteAccessLock(false);
    }
  }, [tracks[0]?.participant?.metadata]) 

  return (
    <>
      {tracks.length > 0 &&
        !(tracks[0].participant instanceof LocalParticipant && !remoteAccessLock) &&
        !isRDPMinized && (
          remoteAccessUserName.length > 0 ? (
            <Tooltip title={`${remoteAccessUserName} has taken the remote access`} arrow>
              <InfoOutlinedIcon style={{ fontSize: "24px", cursor: "pointer", marginTop: "15px", marginRight: "10px" }} />
            </Tooltip>
          ) : (
            <button className="screenShareBtn" onClick={handleUserSelect}>
              <div className="screenShareBtn_flex">
                <span>Remote access</span>
              </div>
            </button>
          )
        )}

  
      {isRDPMinized && (
        <button className="screenShareBtn" onClick={resumeRDP}>
          <div className="screenShareBtn_flex">
            <span>Resume remote access</span>
          </div>
        </button>
      )}
    </>
  );
  
}

export default RemoteControl;